import React, { Fragment, PureComponent } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import breakpoint from 'styled-components-breakpoint';

/* standart */
import Felicia from '../assets/screenshots/standart/felicia.png';
import Invito from '../assets/screenshots/standart/invito.png';
import Limon from '../assets/screenshots/standart/limon.png';
import Maximum from '../assets/screenshots/standart/maximum.png';
import Powerteam from '../assets/screenshots/standart/powerteam.png';
import Purcari from '../assets/screenshots/standart/purcari.png';
import Verde from '../assets/screenshots/standart/verde.png';
import Farmacie from '../assets/screenshots/standart/farmacie.png';
import Gig from '../assets/screenshots/standart/gig.png';
import Lobster from '../assets/screenshots/standart/lobster.png';
import Magnus from '../assets/screenshots/standart/magnus.png';
import Solis from '../assets/screenshots/standart/solis.png';

/* lite */
import LovelyBaby from '../assets/screenshots/lite/lovely.png';
import Pampy from '../assets/screenshots/lite/pampy.png';
// import Yves from '../assets/screenshots/lite/yves.png';
import Soba from '../assets/screenshots/lite/soba.png';
import Joma from '../assets/screenshots/lite/joma.png';
import MamaBox from '../assets/screenshots/lite/mamabox.png';
import GetTape from '../assets/screenshots/lite/gettape.png';
import Promstore from '../assets/screenshots/lite/promstore.png';
import LumiMax from '../assets/screenshots/lite/lumimax.png';
import Bieffe from '../assets/screenshots/lite/bieffe.png';
import Crownperfumes from '../assets/screenshots/lite/crownperfumes.png';
import Agroart from '../assets/screenshots/lite/agroart.png';
import Lightsup from '../assets/screenshots/lite/lightsup.png';

/* landing */
import FeliciaEco from '../assets/screenshots/landing/feliciaeco.png';
import Donat from '../assets/screenshots/landing/donat.png';
import Optigrill from '../assets/screenshots/landing/optigrill.png';
import PartnersLobsterWeight from '../assets/screenshots/landing/lobster.png';

const TabListReact = styled(TabList)`
  display: flex;
  width: 1000px;
  max-width: calc(100vw - 40px);
  margin-bottom: 30px;
`;

const TabReact = styled(Tab)`
  cursor: pointer;
  outline: none;
  color: #777777;
  font-size: 13px;
  line-height: 15px;
  text-align: center;
  border-bottom: 2px solid #d1d1d1;
  padding-bottom: 7px;
  width: 33.33%;

  &[aria-selected='true'] {
    color: #0079ff;
    border-color: #0079ff;
  }

  ${breakpoint('tablet')`
    font-size: 16px;
    line-height: 18px;
    padding-bottom: 14px;
  `};
`;

const CardList = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-bottom: 20px;
  width: 1000px;
  max-width: calc(100vw - 40px);

  ${breakpoint('tablet')`
    flex-direction: row;
    justify-content: space-between;
  `};
`;

const CardWrapper = styled.div`
  border-radius: 3px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #ebebeb;
  width: 1000px;
  max-width: calc(100vw - 40px);
  position: relative;
  margin-bottom: 30px;
  box-sizing: border-box;

  &:nth-child(n + 5) {
    display: none;
  }

  &.empty-card {
    border: none;
  }

  ${breakpoint('tablet')`
    width: 220px;

    margin-bottom: 40px;



    &:nth-child(n + 5) {
      display: flex;
    }

    &:hover {
      & > img {
        filter: brightness(35%);
      }
      & a {
        opacity: 1;
      }
    }
  `};
`;

const CardImage = styled.img`
  width: 100%;
  object-fit: cover;
  height: 280px;

  ${breakpoint('tablet')`
    height: 200px;
  `}
`;

const CardFooter = styled.div`
  text-align: center;
  background-color: #ebebeb;
  color: #787878;
  font-size: 16px;
  line-height: 18px;
  padding: 20px 0;

  ${breakpoint('tablet')`
    padding: 11px 0;
  `};
`;

const CardLink = styled.a`
  position: absolute;
  opacity: 0;
  top: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  border-radius: 3px;
  font-size: 14px;
  line-height: 16px;
  padding: 13px 32px;
  border: 1px solid #fff;
  color: #fff;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);

  ${breakpoint('tablet')`
    top: 45%;
    width: auto;
    height: auto;
  `}
`;

const Card = ({ src, text, link }) => {
  return (
    <CardWrapper className={!src ? 'empty-card' : ''}>
      {src && (
        <Fragment>
          <CardImage src={src} alt="" />
          <CardFooter>{text}</CardFooter>
          <CardLink href={link} rel="noopener noreferrer" target="_blank">
            <FormattedMessage
              id="shop.showcase.redirect"
              defaultMessage="Перейти на сайт"
            />
          </CardLink>
        </Fragment>
      )}
    </CardWrapper>
  );
};

class ShowCase extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      index: 0,
    };
  }

  setIndex = (index: any): void => {
    this.setState({ index });
  };

  render() {
    return (
      <Tabs selectedIndex={this.state.index} onSelect={this.setIndex}>
        <TabListReact>
          <TabReact>Standart</TabReact>

          <TabReact>Lite</TabReact>

          <TabReact>Landing</TabReact>
        </TabListReact>

        <TabPanel>
          <CardList>
            <Card src={Maximum} text="Maximum" link="https://maximum.md/" />
            <Card src={Purcari} text="Purcari" link="https://purcari.wine/" />
            <Card src={Farmacie} text="Farmacie" link="https://farmacie.md" />
            <Card src={Invito} text="Invito" link="https://invito.md/ru/" />
            <Card src={Felicia} text="Felicia" link="https://felicia.md/" />
            <Card src={Gig} text="Gig" link="https://gig.md/" />
            <Card
              src={Powerteam}
              text="Powerteam"
              link="https://powerteam.md/"
            />
            <Card src={Limon} text="Limon" link="https://limon.md/ru/" />
            <Card src={Verde} text="Verde" link="https://verde.md/ru/" />
            <Card
              src={Lobster}
              text="Lobster Weight"
              link="https://lobsterweight.com/"
            />
            <Card src={Magnus} text="Magnus" link="https://magnus.md/" />
            <Card src={Solis} text="Solis" link="https://solis.md/" />
          </CardList>
        </TabPanel>

        <TabPanel>
          <CardList>
            <Card
              src={LovelyBaby}
              text="LovelyBaby"
              link="https://lovelybaby.md/"
            />
            <Card src={Pampy} text="Pampy" link="https://pampy.md/" />
            <Card src={Soba} text="Soba" link="https://soba.md/" />
            <Card src={Joma} text="Joma-Sport" link="https://joma-sport.md/" />
            <Card src={MamaBox} text="MamaBox" link="https://mamabox.md/" />
            <Card src={GetTape} text="GetTape" link="https://gettape.md/" />
            <Card
              src={Promstore}
              text="Promstore"
              link="https://promstore.md/"
            />
            <Card src={LumiMax} text="LumiMax" link="https://lumimax.md/" />
            <Card src={Bieffe} text="Bieffe" link="https://bieffe.md/" />
            <Card
              src={Crownperfumes}
              text="Crownperfumes"
              link="https://crownperfumes.md/"
            />
            <Card src={Agroart} text="Agroart" link="https://agroart.md/" />
            <Card src={Lightsup} text="Lightsup" link="https://lightsup.md/" />
          </CardList>
        </TabPanel>

        <TabPanel>
          <CardList>
            <Card
              src={FeliciaEco}
              text="Felicia Eco"
              link="https://felicia.md/ro/page/felicia_eco/"
            />
            <Card src={Donat} text="Donat" link="http://donat.md/" />
            <Card
              src={Optigrill}
              text="Optigrill"
              link="http://optigrill.maximum.md/"
            />
            <Card
              src={PartnersLobsterWeight}
              text="Partners Lobster Weight"
              link="https://lobsterweight.com/"
            />
            <Card />
            <Card />
          </CardList>
        </TabPanel>
      </Tabs>
    );
  }
}

export default ShowCase;
